import { FC, ReactElement, useEffect } from 'react';

import { useLocalStorage } from 'react-use';

import { CookieSettings } from '../../containers';
import { useCookieSettings, useCookieSettingsDispatch } from '../../context';
import { CookieSettingsData, CookieType, CookieTypeConfiguration } from '../../entities/Cookie/Cookie';
import { GTMEvent } from '../../entities/GTM/GTM';
import { sendGTMEvent } from '../../entities/GTM/GTMService';

export const ConnectedCookieSettings: FC = (): ReactElement => {
    const { cookieSettingsVisible } = useCookieSettings();

    const dispatchCookieSettings = useCookieSettingsDispatch();

    const [storedCookieSettings] = useLocalStorage<CookieSettingsData>('cookieSettings', undefined);

    useEffect((): void => {
        if (storedCookieSettings) {
            const marketingCookieConsent = storedCookieSettings[CookieType.marketing] ? 'granted' : 'denied';
            const analyticalCookieConsent = storedCookieSettings[CookieType.analytical] ? 'granted' : 'denied';

            sendGTMEvent(GTMEvent.consent, {
                consent: {
                    ad_storage: marketingCookieConsent,
                    ad_user_data: marketingCookieConsent,
                    ad_personalization: marketingCookieConsent,
                    analytics_storage: analyticalCookieConsent,
                },
            });
        }
    }, []);

    const handleUpdateCookieSettings = (configuration: CookieTypeConfiguration) => {
        dispatchCookieSettings({
            ...configuration,
            cookieSettingsVisible: false,
            cookieSettingsConfigured: true,
        });

        const marketingCookieConsent = configuration[CookieType.marketing] ? 'granted' : 'denied';
        const analyticalCookieConsent = configuration[CookieType.analytical] ? 'granted' : 'denied';

        const consentData = {
            ad_storage: marketingCookieConsent,
            ad_user_data: marketingCookieConsent,
            ad_personalization: marketingCookieConsent,
            analytics_storage: analyticalCookieConsent,
        };

        const consentBody = storedCookieSettings?.cookieSettingsConfigured
            ? { update: consentData }
            : consentData;

        sendGTMEvent(GTMEvent.consent, {
            consent: consentBody,
        });
    };

    return (
        <CookieSettings
            isRevealed={cookieSettingsVisible}
            onUpdateCookieSettings={handleUpdateCookieSettings}
        />
    );
};
